import styled, { DefaultTheme, ThemedStyledProps } from 'styled-components';
import { cssValue } from 'styles/utils';
import { getThemeColor } from 'utils/styled';
import { BASE_BORDER_RADIUS, BORDER_WEIGHT_NAMES } from './constants';
import {
  ContainerBorderWeight,
  ContainerStyleProps,
  ContainerBorderWeightName,
} from './types';

const NAMED_BORDER_WIDTHS: Record<ContainerBorderWeightName, string> = {
  thin: '1px',
  regular: '2px',
};

function isNamedBorderWidth(
  value: ContainerBorderWeight,
): value is ContainerBorderWeightName {
  return BORDER_WEIGHT_NAMES.includes(value as ContainerBorderWeightName);
}

function getBorderWidth(
  props: ThemedStyledProps<ContainerStyleProps, DefaultTheme>,
) {
  const { $borderWeight } = props;

  if (isNamedBorderWidth($borderWeight)) {
    return NAMED_BORDER_WIDTHS[$borderWeight];
  }
  return cssValue($borderWeight);
}

function getBorderRadius(
  props: ThemedStyledProps<ContainerStyleProps, DefaultTheme>,
) {
  const { $cornerRadius } = props;

  if (typeof $cornerRadius === 'string') {
    return $cornerRadius;
  }

  return `${$cornerRadius * BASE_BORDER_RADIUS}px`;
}

function getGutter(
  props: ThemedStyledProps<ContainerStyleProps, DefaultTheme>,
) {
  const { $gutter, theme } = props;

  if (typeof $gutter === 'string') {
    return $gutter;
  }

  return `${$gutter * theme.spacing.base}px`;
}

export const Root = styled.div<ContainerStyleProps>`
  background-color: ${getThemeColor('l2')};
  border-color: ${getThemeColor('l4')};
  border-radius: ${getBorderRadius};
  border-style: solid;
  border-width: ${getBorderWidth};
  color: ${getThemeColor('d1')};
  padding: ${getGutter};
`;
